<template>
  <v-card
    :class="{ 'mx-4' : $vuetify.display.mdAndUp }"
    :disabled="loading"
    :loading="loading"
    color="primary"
  >
    <template #loader="{ isActive }">
      <v-progress-linear
        :active="isActive"
        color="white"
        height="4"
        indeterminate
      />
    </template>
    <div
      v-tooltip:top="'Click here to refresh the data immediately'"
      :class="{
        'flex-row' : $vuetify.display.smAndDown,
        'flex-column' : $vuetify.display.mdAndUp,
      }"
      class="d-flex justify-center my-4 mx-4 cursor-pointer"
      @click="load"
    >
      <div class="d-flex justify-center items-center">
        <v-progress-circular
          v-model="percentageRaw"
          color="#F4F0DD"
          size="70"
          width="10"
        >
          <p class="font-weight-bold">
            {{ percentageDisplay }}%
          </p>
        </v-progress-circular>
      </div>
      <div class="d-flex justify-center items-center mt-4">
        <p class="text-center">
          You are using <strong>{{ percentageDisplay }}%</strong> of the <strong>{{ total }}</strong> of disk space available
          on your current subscription.
        </p>
      </div>
    </div>
  </v-card>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import {useQuotaStore} from "@/stores/quota"

export default defineComponent({
  computed: {
    loading(): boolean {
      return useQuotaStore().loading
    },
    percentageRaw(): number {
      return useQuotaStore().raw
    },
    percentageDisplay(): string {
      return useQuotaStore().display
    },
    total(): string {
      return this.$file.formatFileSize(useQuotaStore().total)
    }
  },
  async mounted() {
    await this.load()
  },
  methods: {
    async load() {
      await useQuotaStore().refresh()
    }
  }
})
</script>

<style lang="scss" scoped>
:deep(.v-progress-circular__underlay) {
  color: #767676 !important;
}

:deep(.v-progress-circular__overlay) {
  stroke-linecap: round;
}
</style>
